import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { getSpaceEndpointUrl } from '@/api/services/serverless/space';
import { COLLECTIONS_TABLE_PAGE_SIZE } from '@/api/services/serverless/space-collections';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/collections/',
)({
  // Not awaited: the tab shows its frame and a skeleton while the list loads.
  loader: async ({ context: { queryClient, spaceQuery, listCollectionsQuery } }) => {
    const { space } = await queryClient.ensureQueryData(spaceQuery);
    const baseUrl = getSpaceEndpointUrl(space);
    if (baseUrl) {
      void queryClient.prefetchInfiniteQuery(listCollectionsQuery(baseUrl, COLLECTIONS_TABLE_PAGE_SIZE));
    }
  },
  component: lazyRouteComponent(
    () => import('@/components/Serverless/SpaceCollections/SpaceCollections'),
    'SpaceCollections',
  ),
});
